'use strict';
import defaultsDeep from 'lodash/defaultsDeep';
import isUndefined from 'lodash/isUndefined';
import {assignOrganizationToModel,} from '../../app/model/actions';
import {getOrganization, getUser} from '../../app/model/reducers/state';
import {getAsLink, getId} from '../../core-utilities/domain/ReduxUtils';
import {reactReduxModal as peopleSelectorModal} from '../../personnel/redux/peopleSelectorModal';
import formTemplate from './modals/form-selector-panel.html';
import personnelTemplate from './modals/personnel-selector.html';
import privatePersonnelTemplate from './modals/private-personnel-selector.html';


module.exports = [
  '$modal',
  '$ngRedux',
  'UserDomain',
  SelectorsService];

function SelectorsService(
  $modal,
  $ngRedux,
  UserDomain,
) {
  this.selectOrganization = selectOrganization;
  this.selectPersonnel = selectPersonnel;
  this.selectPersonnelForTarget = selectPersonnelForTarget;
  this.selectPersonnelRedux = selectPersonnelRedux;
  this.selectForm = selectForm;

  const defaultPersonnelExclusions = {
    teams: false,
    nonUsers: false
  };

  function selectOrganization(currentValue, currentFilter) {
    const rootState = $ngRedux.getState();
    return $modal.showBasicSelector({
      locals: {
        user: getUser(rootState),
        config: {
          header: 'organizations.select.header.label'
        },
        currentValue: !isUndefined(currentValue) ? currentValue : getOrganization(rootState),
        currentFilter: currentFilter,
        loadList: () => UserDomain.$getOrganizationsList(getId(getUser(rootState))),
      }
    }).then(function (organization) {
      $ngRedux.dispatch(assignOrganizationToModel(organization));
    });
  }

  /**
   *
   * @param currentValue
   * @param currentFilter
   * @param {?String} nullLabel - Optional label to display for selecting no user
   * @param {?Object} exclusions - Optional filters to exclude some classes of personnel from the list
   * @param {?boolean} [exclusions.teams=false] - removes teams from the list
   * @param {?boolean} [exclusions.nonUsers=false] - Removes non-users from the list
   * @param {Object} [overrideOrg]
   * @returns {*}
   */
  function selectPersonnel(currentValue, currentFilter, nullLabel, exclusions, overrideOrg) {
    // return selectPersonnelRedux({
    //   selected: currentValue,
    //   filter: currentFilter,
    //   nullLabel,
    //   exclusions,
    //   overrideOrg,
    // });

    return $modal.showBasicSelector({
      template: personnelTemplate,
      controller: 'PersonnelSelectController',
      locals: {
        currentValue: currentValue,
        currentFilter: currentFilter,
        nullLabel: nullLabel,
        exclusions: {...defaultPersonnelExclusions, ...(exclusions || {})},
        overrideOrg: overrideOrg
      }
    });
  }

  function selectPersonnelForTarget(target, currentValue, currentFilter, nullLabel, exclusions) {
    // return selectPersonnelRedux({
    //   target,
    //   selected: currentValue,
    //   filter: currentFilter,
    //   nullLabel,
    //   exclusions,
    //   overrideOrg,
    // });
    return $modal.showBasicSelector({
      template: privatePersonnelTemplate,
      controller: 'PrivatePersonnelSelectController',
      locals: {
        target: target,
        currentValue: currentValue,
        currentFilter: currentFilter,
        nullLabel: nullLabel,
        exclusions: {...defaultPersonnelExclusions, ...(exclusions || {})},
      }
    });
  }

  /**
   * @param o
   * @return {Promise<any>}
   */
  function selectPersonnelRedux(o) {
    return new Promise((resolve, reject) => {
      const options = {};
      defaultsDeep(options, o, {
        // legacy options exclusions
        useSimple: false,
        exclusions: {
          teams: false,
          users: false,
          nonUsers: false,
        },
      });
      const exclude = {...(options.exclusions || {}), ...(o.exclusions || {})};
      const payload = {
        parentId: options.overrideOrg ? options.overrideOrg : getId(getOrganization($ngRedux.getState())),
        // TODO: if this is a domain instance, we need to convert it to a pojo first
        useSimple: options.useSimple,
        selected: options.selected,
        filterOptions: {
          includeTeams: !exclude.teams,
          expandTeams: !!options.target,
          includeUsers: !exclude.users,
          includeNonUsers: !exclude.nonUsers,
        },
        nullable: true,
      };

      if (options.nullLabel) {
        payload.nullLabel = options.nullLabel;
      }

      if (options.filter) {
        payload.filter = options.filter;
      }

      if (options.target) {
        payload.filterOptions.target = getAsLink(options.target);
      }

      $ngRedux.dispatch(peopleSelectorModal.actions.showModal(payload, {resolve, reject}));
    });
  }

  function selectForm(currentValue, currentFilter) {
    return $modal.showBasicSelector({
      template: formTemplate,
      controller: 'FormSelectorPanelController',
      locals: {
        currentValue: currentValue,
        currentFilter: currentFilter
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/core-components/selectors/SelectorsService.js